import {TheRaveNormalResultPresentation} from "./TheRaveNormalResultPresentation";
import {TheRave} from "../TheRave";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TheRaveReelController} from "../reels/TheRaveReelController";
import {ReelState} from "../../core/reel/ReelState";
import {TheRaveEnhancerReelController} from "../reels/TheRaveEnhancerReelController";
import {TheRaveParsedGameData} from "../server/data/TheRaveParsedGameData";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TheRaveGameConfig} from "../TheRaveGameConfig";

export class TheRaveSuperFsResultPresentation extends TheRaveNormalResultPresentation {

    constructor() {
        super();
    }

    public start(flowStateController: FlowStateController): void {
        flowStateController.setSkipCallback(() => this.skip());
        TheRave.reelStopPresentations.start().then(res => flowStateController.finish());
        const featureSignDelay: number = this.startFeatureSign();
        this.getReelsStopResult(false, Math.max(featureSignDelay, 0.01));
    }

    protected getReelsStopResult(quickStop: boolean, delay: number): void {
        let spinStopOffset: number = 0;
        TheRave.reels.forEach((spinReel: TheRaveReelController) => {
            if (spinReel.reelState === ReelState.SPIN) {
                spinStopOffset = Math.max(
                    spinStopOffset,
                    spinReel.getSpinStopOffset());
            }
        });


        TheRave.enhancerReels.forEach((reel: TheRaveEnhancerReelController, reelId: number) => {
            if (TheRave.model.currentParsedData.enhancerReel[reelId]) {
                delay += this.getReelStopDelay(reel, quickStop);
                reel.tryStop(TheRave.model.reels[reelId + 5].concat(), 0, delay + (quickStop ? 0 : 1), quickStop);
            } else {
                reel.tryStop(["X"], 0, delay, true);
            }// This is a rough estimated time, the reel will take the real time when it's stopping.
        });


        delay += 1;
        const reelDelay: number[] = [];
        let firstLink: boolean = false;

        TheRave.model.parsedGameData.doLinkedReels.forEach((isLinked: boolean, reelId: number) => {
            const reel = TheRave.reels[reelId];
            if (isLinked) {
                if (!firstLink) {
                    firstLink = true;
                    delay += TheRaveGameConfig.reelStopNearWinSpin;
                } else {
                    delay += 0.1;
                }
            } else {
                delay += this.getReelStopDelay(reel, quickStop);
            }

            reelDelay.push(delay);
        });

        this._reelStopOrder.forEach((reelId: number, order: number) => {
            const reel = TheRave.reels[reelId];
            reel.tryStop(spinStopOffset, reelDelay[order], quickStop, () => Logger.logDev(`Reel ${reelId} stopping.`), this._reelStopOrder[order + 1]);
        });
    }

    private startFeatureSign(): number {
        const parsedGameData: TheRaveParsedGameData = TheRave.model.parsedGameData;

        if (parsedGameData.doTransformToM1) {
            TheRave.randomFeatureSign.show("mashup");
            return 2;
        }
        if (parsedGameData.doLinkedReels.indexOf(true) > -1) {
            TheRave.randomFeatureSign.show("sidechain");
            TheRave.reelHighlighter.show(parsedGameData.doLinkedReels);
            return 3;
        }
        if (parsedGameData.doLowToWildReels.indexOf(true) > -1) {
            TheRave.randomFeatureSign.show("crossfader");
            TheRave.model.parsedGameData.doLowToWildReels.forEach((hasWild: boolean, reelId: number) => {
                const reel = TheRave.reels[reelId];
                if (hasWild) {
                    reel.reelView.highLight();
                }
            });
            return 2;
        }
        return 0;
    }

    protected skip(): void {
        super.skip();
        TheRave.reelHighlighter.skip();
    }
}